import React, { useCallback, useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { banners } from '../data/banners';
const AUTOPLAY_MS = 6000;
const arrowClass = 'absolute top-1/2 z-10 flex h-12 w-12 -translate-y-1/2 items-center justify-center rounded-full border border-white/40 bg-white/15 text-white shadow-[0_8px_24px_rgba(0,0,0,0.25)] backdrop-blur-md transition hover:scale-105 hover:bg-white/30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white';
export function HeroSlider() {
  const [[index, direction], setState] = useState<[number, number]>([0, 0]);
  const [paused, setPaused] = useState(false);
  const hasMany = banners.length > 1;
  const go = useCallback((dir: number) => {
    setState(([i]) => [(i + dir + banners.length) % banners.length, dir]);
  }, []);
  const goTo = (i: number) => setState(([current]) => [i, i > current ? 1 : -1]);
  useEffect(() => {
    if (!hasMany || paused) return;
    const id = window.setTimeout(() => go(1), AUTOPLAY_MS);
    return () => window.clearTimeout(id);
  }, [index, paused, hasMany, go]);
  const banner = banners[index];
  return <section id="inicio" aria-roledescription="carrusel" aria-label="Banners principales" className="relative w-full overflow-hidden bg-primary" onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)} data-id="element-281" data-mp="kfhfx2llr9h8">
      {/* Full-width, keeps the banners' 2:1 ratio so no text is cropped */}
      <div className="relative aspect-[2/1] w-full" data-id="element-282" data-mp="5h6zh0ig7ios">
        <AnimatePresence initial={false} custom={direction} data-id="element-283" data-mp="1gvipyt7i2il">
          <motion.img key={banner.id} src={banner.image} alt={banner.alt} custom={direction} variants={{
          enter: (d: number) => ({
            opacity: 0,
            x: d === 0 ? 0 : `${d * 100}%`
          }),
          center: {
            opacity: 1,
            x: 0
          },
          exit: (d: number) => ({
            opacity: 0,
            x: `${d * -100}%`
          })
        }} initial="enter" animate="center" exit="exit" transition={{
          duration: 0.8,
          ease: [0.22, 1, 0.36, 1]
        }} className="absolute inset-0 h-full w-full object-cover" data-id="element-284" data-mp="1j993ucxyqjt" />
        </AnimatePresence>

        {hasMany && <>
            <button type="button" onClick={() => go(-1)} aria-label="Banner anterior" className={`${arrowClass} left-3 md:left-6`} data-id="element-285" data-mp="25zmj4og8zrmd">
              <ChevronLeftIcon className="h-5 w-5" data-id="element-286" data-mp="2tmupl9pex6pz" />
            </button>
            <button type="button" onClick={() => go(1)} aria-label="Banner siguiente" className={`${arrowClass} right-3 md:right-6`} data-id="element-287" data-mp="2xpr2qkw6oamj">
              <ChevronRightIcon className="h-5 w-5" data-id="element-288" data-mp="2opm2cupeqchv" />
            </button>
            <div className="absolute bottom-3 left-1/2 z-10 flex -translate-x-1/2 items-center gap-2 rounded-full border border-white/30 bg-white/15 px-3 py-2 backdrop-blur-md md:bottom-5" data-id="element-289" data-mp="2onrkxqdch2ij">
              {banners.map((b, i) => <button key={b.id} type="button" onClick={() => goTo(i)} aria-label={`Ir al banner ${i + 1}`} aria-current={i === index} className="relative h-2 overflow-hidden rounded-full bg-white/40 transition-all" style={{
            width: i === index ? 32 : 8
          }} data-id="element-290" data-mp="15qo60a3ndes0" data-mpi={i}>
                  {i === index && <motion.span key={`${b.id}-${paused}`} className="absolute inset-y-0 left-0 bg-accent-gold" initial={{
              width: '0%'
            }} animate={{
              width: paused ? '0%' : '100%'
            }} transition={{
              duration: paused ? 0 : AUTOPLAY_MS / 1000,
              ease: 'linear'
            }} data-id="element-291" data-mp="m3qkq8quiwnu" />}
                </button>)}
            </div>
          </>}
      </div>
    </section>;
}